import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  memberStateExcludeCyprusList: any;
  VatReturnsReceivedList: {
    status: StateStatus | null;
    data: any;
  };
  unreadNotificationCount: {
    status: StateStatus | null;
    data: number;
  };
  PaymentReceivedDetailList: {
    status: StateStatus | null;
    data: any;
  };
}

const initialState: IState = {
  memberStateExcludeCyprusList: {
    status: null,
    data: null,
  },
  VatReturnsReceivedList: {
    status: null,
    data: null,
  },
  unreadNotificationCount: {
    status: null,
    data: 0,
  },
  PaymentReceivedDetailList: {
    status: null,
    data: null,
  },
};

const VatReturnsReceivedListReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS:
      return {
        ...state,
        memberStateExcludeCyprusList: {
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_VAT_RETURN_RECEIVED_LIST:
      return {
        ...state,
        VatReturnsReceivedList: {
          ...state.VatReturnsReceivedList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.VatReturnsReceivedList.data
              : action.data,
        },
      };
    case Types.SET_UNREAD_NOTIFICATION_COUNT:
      return {
        ...state,
        unreadNotificationCount: {
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.unreadNotificationCount.data
              : action.data,
        },
      };
    case Types.SET_PAYMENT_RECEIVED_DETAIL_LIST:
      return {
        ...state,
        PaymentReceivedDetailList: {
          ...state.PaymentReceivedDetailList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.PaymentReceivedDetailList.data
              : action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default VatReturnsReceivedListReducer;

/**
 * Add new Page Steps:
 *
 * navigation -> config -> index.tsx
 * navigation -> config -> Routes.tsx
 *
 */
